// extracted by mini-css-extract-plugin
export default {"navigation":"styles_navigation__1RFbz","item":"styles_item__kNaSi","link":"styles_link__WIwta","link-active":"styles_link-active__w1izV","currency":"styles_currency__1IqRs"};